import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OffboardingArchive } from '../../models/offboarding.model';
import { workflowTrackBy } from '../common/employee-assets/asset.helpers';

@Component({selector: 'app-offboarding-archive-detail', templateUrl: './offboarding-archive-detail.component.html',
  styleUrls: ['../common/employee-assets/employee-assets.component.css', './offboarding-archive-detail.component.css']})
export class OffboardingArchiveDetailComponent {
  @Input() item: OffboardingArchive;
  trackBy = workflowTrackBy;
  constructor(public modal: NgbActiveModal) {}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-archive-detail.component.ts